// Cells starting with these are run as formulas by Excel/Sheets, so they get a leading quote.
// A lone character (e.g. a "-" placeholder) can't form a formula and is left as is.
const FORMULA_PREFIX = /^[=+\-@\t\r][\s\S]/;

const toCsvCell = (value) => {
  let text = value === null || value === undefined ? "" : String(value);
  if (FORMULA_PREFIX.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

/**
 * Downloads rows (an array of arrays) as a UTF-8 CSV. The BOM keeps non-Latin text
 * readable when the file is opened in Excel.
 */
export const downloadCsv = (filename, rows = []) => {
  const csvContent = rows.map((row) => row.map(toCsvCell).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
